/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/alternativ-artikel-button/shop.alternativ-artikel-button.component.ts.
 */
import {Component, Input} from '@angular/core';
import {Artikel} from '../../../../models/artikel';
import {MatDialog} from '@angular/material/dialog';
import {
  ShopDialogsAlternativArtikelSucheComponent
} from '../../dialogs/alternativ-artikel-suche/shop.dialogs.alternativ-artikel-suche.component';
import {View} from '../../../../models/view';
import {AppAsyncTimeout} from '../../../../helpers/app.asyncTimeout';
import {AppViewService} from '../../../../services/app.view.service';

/**
 * Zweck: Beschreibt class ShopAlternativArtikelButtonComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: 'alternativ-artikel-button',
    templateUrl: 'shop.alternativ-artikel-button.component.html',
    styleUrls: ['shop.alternativ-artikel-button.component.scss'],
    standalone: false
})
export class ShopAlternativArtikelButtonComponent {
  @Input() disabled = false;
  @Input() artikel: Artikel;
  @Input() view: View;
  @Input() view_slug: string;

  dialogCooldown = false;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private dialog: MatDialog, private vsvc: AppViewService) {
  }

/**
 * Beschreibt Methode check und ihren Rückgabevertrag.
 */
  check() {
    if (!this.dialogCooldown) {
      this.dialogCooldown = true;

      if (!this.view && this.view_slug) {
        this.view = this.vsvc.getViewBySlug(this.view_slug);
      }

      AppAsyncTimeout.setTimeout(() => {
        this.dialogCooldown = false;
      }, 300);
      this.dialog.open(
        ShopDialogsAlternativArtikelSucheComponent,
        {
          data: {
            artikel: this.artikel,
            view: this.view
          },
          width: '99vw',
          minWidth: '99vw'
        }
      );
    }

  }
}
